// FilterContext.js (simplified extract)
import React, { createContext, useContext, useState, useEffect } from "react";

const FilterContext = createContext();

export function FilterProvider({ children }) {
  const [filters, setFilters] = useState({});

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
  };

  // Initialize filters from URL params only once on mount
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const initialFilters = {};

    for (const [key, value] of searchParams.entries()) {
      // Skip sort parameter as it's handled separately
      if (key === 'sort') continue;
      if (!initialFilters[key]) initialFilters[key] = [];
      initialFilters[key].push(value);
    }

    setFilters(initialFilters);
  }, []);

  return (
    <FilterContext.Provider value={{ filters, updateFilters }}>
      {children}
    </FilterContext.Provider>
  );
}

export function useFilter() {
  return useContext(FilterContext);
}
